import React from 'react';
import styles from './styles.module.css';
import AboutStatCard from './AboutStatCard';

export default function AboutStats() {
  const stats = [
    { value: '۲٫۴ م', label: 'کاربر فعال' },
    { value: '۱۸ م', label: 'استعلام موفق' },
    { value: '۳۲', label: 'برند خودرو' },
    { value: '۴٫۸', label: 'امتیاز کاربران' },
  ];
  return (
    <div className={styles.grid}>
      {stats.map((item, index) => (
        <AboutStatCard key={index} item={item} />
      ))}
    </div>
  );
}
